import { getCategoryOneList, getCategoryTwoList, getCategoryGoodsList } from "@/api/categories";

export default {
  namespaced: true,
  actions: {
    async getCategoryOneList() {
      const { data } = await getCategoryOneList();
      return data;
    },

    async getCategoryTwoList(context, params) {
      const { data } = await getCategoryTwoList(params);
      return data;
    },

    async getCategoryGoodsList(context, params) {
      const { data } = await getCategoryGoodsList(params);
      return data;
    }
  }
};
